'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_TestingPage$Test(name, callback) {
  this.SR = null;
  this.SQ = null;
  this.SR = name;
  this.SQ = callback;
}
export { $c_Lmealorama_pages_TestingPage$Test as $c_Lmealorama_pages_TestingPage$Test };
$p = $c_Lmealorama_pages_TestingPage$Test.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_TestingPage$Test;
/** @constructor */
function $h_Lmealorama_pages_TestingPage$Test() {
}
export { $h_Lmealorama_pages_TestingPage$Test as $h_Lmealorama_pages_TestingPage$Test };
$h_Lmealorama_pages_TestingPage$Test.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-285086269), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_TestingPage$Test)) {
    if ((this.SR === x$0.SR)) {
      var x = this.SQ;
      var x$2 = x$0.SQ;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "Test";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.SR;
  }
  if ((n === 1)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_AsyncCallback(this.SQ);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_TestingPage$Test(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kH)));
}
export { $isArrayOf_Lmealorama_pages_TestingPage$Test as $isArrayOf_Lmealorama_pages_TestingPage$Test };
var $d_Lmealorama_pages_TestingPage$Test = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_TestingPage$Test, "mealorama.pages.TestingPage$Test", ({
  kH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_TestingPage$Test as $d_Lmealorama_pages_TestingPage$Test };
//# sourceMappingURL=mealorama.pages.-Testing-Page$-Test.js.map
